import { AlternativeRatings, Ratings } from '@atlassian/amkt-common';
import { LinkClickedEvent, useAnalyticsEvents } from '@atlassian/mpac-analytics';
import { useFeatureFlags } from '@atlassian/mpac-feature-flags';
import { UrlUtils, WindowUtils } from '@atlassian/mpac-utils';
import React from 'react';
import { useHistory } from '../../../../primitives/Router';
import { ANALYTICS_SUBJECT_ID_RATINGS } from '../../AppHeader.constants';
const HeaderRatings = props => {
  const history = useHistory();
  const {
    showAlternativeRatingsComponent
  } = useFeatureFlags();
  const {
    appRatingLink,
    openMarketplaceLinksInNewTab,
    appKey,
    ratings
  } = props;
  const fireAnalyticsEvent = useAnalyticsEvents();
  const onRatingsClick = () => {
    fireAnalyticsEvent({
      eventType: LinkClickedEvent,
      actionSubjectId: ANALYTICS_SUBJECT_ID_RATINGS
    });
    if (openMarketplaceLinksInNewTab) {
      const appReviewsUrl = appRatingLink.expand({
        appKey
      });
      WindowUtils.openPage(appReviewsUrl, '_blank');
    } else {
      history === null || history === void 0 ? void 0 : history.push(UrlUtils.updateQueryParam(window.location.href, 'tab', 'reviews'));
    }
  };
  return showAlternativeRatingsComponent ? /*#__PURE__*/React.createElement(AlternativeRatings, {
    ratings: ratings,
    onClick: ratings.numRatings ? onRatingsClick : undefined
  }) : /*#__PURE__*/React.createElement(Ratings, {
    ratings: ratings,
    onClick: onRatingsClick
  });
};
export default HeaderRatings;